import {Component, Input, OnInit} from '@angular/core';
import {BokkzVpbDataService, BokkzVpbLogic, VpbAangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-investeringen-overig',
  templateUrl: './tekst-investeringen-overig.component.html',
  styleUrls: ['./tekst-investeringen-overig.component.scss'],
  imports: [
    CommonModule
  ]
})
export class TekstInvesteringenOverigComponent implements OnInit {

  @Input() public id!: string;
  public vpbAangifte = <VpbAangifte>{};
  public focusedElementId: string | null = null;
  public year = 2024;

  constructor(
      public dataService: BokkzVpbDataService,
      public vpbService: BokkzVpbLogic,
      private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.dataService.corporateTaxEntity.subscribe((value)=> {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}
